import MetaInfoRepository from "../api/metaInfo.js"

class MetaInfoUseCase {
    constructor() {
        /** @type {MetaInfoRepository}*/
        this.api = new MetaInfoRepository()
    }

    /**
     *
     * @param typeMetaInfo {string}
     * @return {Promise<{data: MetaInfo, err: null}|{data: null, err: ErrorState}>}
     */
    async getMeta(typeMetaInfo) {
        const {data, err} = await this.api.getMeta(typeMetaInfo)
        if (err && err === "record not found") {
            return {data: null, err: null}
        }
        return {data, err}
    }
}

export default new MetaInfoUseCase()
